import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IProfileRepository } from '../../repositories/interfaces/iProfileRepository';

export interface IGetFavoriteChannelsUseCase {
    execute(apiKey: string, profileGuid: string, token: string, identityToken: string, query: any): Promise<any>;
}

export class GetFavoriteChannelsUseCase implements IGetFavoriteChannelsUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get profileRepository(): IProfileRepository {
        return container.resolve<IProfileRepository>(DI.REPOSITORIES.IProfileRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(apiKey: string, profileGuid: string, token: string, identityToken: string, query: any): Promise<any> {
        const result = await this.profileRepository.getFavoriteChannels(
            apiKey,
            profileGuid,
            token,
            identityToken,
            query
        );
        return result.data.ids || [];
    }
}
